import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFilterProductsList, getProductStatusList, getStorageIdList, productBackDetails } from "../../../store/actions/incoming";
import _ from "lodash";
import DatePickerComponent from "../../common/DatePickerComponent";
import Select from "react-select";
import { getSelectList, computeAutoSelectedSellers } from "../../../config/utils";
import { fetchCompanyFilters, getAllCompanyDetails, getFilterSellers } from "../../../store/actions/rateCard";
import moment from "moment";
import { getAllSellersList } from "../../../store/actions";
import PropTypes from "prop-types";
import { BillingStatusList, COMPANY_DROPDOWN_PAGE_SIZE, ReturnProductTypeList } from "../../../constant";

/* istanbul ignore next */
function useOutsideAlerter(ref) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setFilterValue({ ...filterValue, showFilter: false });
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const FilterProduct = (props) => {
  const { filterValue, setFilterValue, handleReset, setLoader, sellerList, setSellerList, allSellers, setAllSellers, filterType, isSuperAdminUser } = props;
  const UserValue = useSelector((state) => state.auth.user);
  const {storageIdList} = useSelector((state) => state.IncomingReducer);
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  const [warehouseTypeList, setwarehouseTypeList] = useState([]);
  const [conditionList, setconditionList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const { filterCompanies, filterSellers, filterAllSellers, getAllCompany } = useSelector((state) => state.RateCardReducer);
  const [companyList, setCompanyList] = useState([]);
  const [storageIdListing, setStorageIdListing] = useState([]);

  useEffect(() => {
    if (storageIdList.length){
      setStorageIdListing(storageIdList);
    }
  }, [storageIdList]);

  useOutsideAlerter(wrapperRef);
  const productConditionListData = useSelector(
    (state) => state?.IncomingProductReducer?.productConditionList
  );
  const productStatusListData = useSelector(
    (state) => state?.IncomingProductReducer?.productStatusList
  );
  const productWarehouseListData = useSelector(
    (state) => state?.IncomingProductReducer?.productWarehouseList
  );
  const productwarehouseListData = useSelector(
    (state) => state?.IncomingProductReducer?.productwarehouseList
  );
  useEffect(() => { 
    let companyList = isSuperAdminUser
      ? getAllCompany?.Entity?.listCompanyMasterOrdersEntity || []
      : filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
    let sellerList = filterAllSellers?.EntityList || [];

    if (companyList.length) {
      setCompanyList(getSelectList(companyList, 'Id', 'name'));
    }
    if (sellerList.length) {
      setAllSellers(getSelectList(sellerList, 'id', 'sellerName'));
      setSellerList(getSelectList(sellerList, 'id', 'sellerName'));
    }
  }, [filterCompanies, filterSellers, filterAllSellers, getAllCompany, isSuperAdminUser]);

  useEffect(() => {
    let data = {
      pageIndex: 1,
      pageSize: 10,
      sortColumn: 'name',
      sortOrder: 'ascending',
      processingDateTo: '',
      processingDateFrom: ''
    };
    let sellerData = {
        "pageIndex": 1,
        "pageSize": 10,
        "sortColumn": "name",
        "sortOrder": "ASCENDING",
        "companyIdList": [0],
        screenType: 2,
    };
    if (isSuperAdminUser) {
      dispatch(getAllCompanyDetails(null, COMPANY_DROPDOWN_PAGE_SIZE, 1));
    } else {
      dispatch(fetchCompanyFilters(data));
    }
    dispatch(getFilterSellers(sellerData));
    if (!storageIdList.length){
      fetchStorageIdList();
    }
  }, [isSuperAdminUser]);

  useEffect(() => {
    let productConditionListCopyObj = JSON.parse(JSON.stringify(productConditionListData || []));
    let productWarehouseListObj = JSON.parse(JSON.stringify(productWarehouseListData || []) || []);
    let productwarehouseListObj = JSON.parse(JSON.stringify(productwarehouseListData || []) || []);
    setconditionList(getSelectList(productConditionListCopyObj, 'id', 'condition') || []);
    if (isSuperAdminUser) {
      setwarehouseTypeList(getSelectList(productWarehouseListObj, 'id', 'location'));
    } else {
      setwarehouseTypeList(getSelectList(productwarehouseListObj, 'id', 'location'));
    }
  }, [productConditionListData, productwarehouseListData, productWarehouseListData, isSuperAdminUser]);

  useEffect(() => {
    if (productStatusListData?.length) {
      setStatusList(getSelectList(JSON.parse(JSON.stringify(productStatusListData)), 'id', 'status'));
    }
  }, [productStatusListData]);

  useEffect(() => {
    if (!productStatusListData?.length) {
      dispatch(getProductStatusList());
    }
  }, []);

  const handleChangeFilter = (value, name) => {
    setFilterValue({ ...filterValue, [name]: value });
    if (name === "companyIdList") {
      let companyData = _.map(value, "Id");
      fetchSellers(companyData);
      if (filterValue?.sellerIdList?.length) {
        const filteredSellers = filterValue.sellerIdList.filter(seller =>
          companyData.includes(parseInt(seller.companyIds)) // NOSONAR
        );
        setFilterValue({ ...filterValue, sellerIdList: filteredSellers, companyIdList: value })
      }
    }
  };

  const fetchStorageIdList = async () => {
    let payload = {
      searchKeywords: "",
    };
    dispatch(getStorageIdList(payload));
  }

  const fetchSellers = async (companyList) => {
    if (companyList.length === 0) {
      setSellerList(allSellers);
      return;
    }
    let data = {
      companyIds: companyList,
    };
    let res = await getAllSellersList(data);
    if (res?.data?.Status === 200) {
      let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
        (item) => {
          return {
            ...item,
            label: item.sellerAndCompany,
            value: item.id,
          };
        }
      );
      setSellerList(dataList);
      // Auto-select sellers for any selected company that has exactly one seller
      setFilterValue((prev) => {
        const merged = computeAutoSelectedSellers(dataList, companyList, prev?.sellerIdList || []);
        if (merged.length === (prev?.sellerIdList?.length || 0)) return prev;
        return { ...prev, sellerIdList: merged };
      });
    }
  };

  const handleApplyFilter = () => {
    setLoader(true)
    let data = { ...props.filterValue, userId: UserValue?.Value?.employeeId };
    data.pageIndex = 1;
    data.sortColumn = '';
    data.warehouseList = _.map(filterValue.warehouseList, "id");
    data.conditionList = _.map(filterValue.conditionList, "id");
    data.sellerIdList = _.map(filterValue.sellerIdList, "value");
    data.companyIdList = _.map(filterValue.companyIdList, "Id");
    data.returnProductType = _.map(filterValue.returnProductType, "value");
    data.productStatusId = _.map(filterValue.productStatusId, "id");
    data.processingDateFrom = filterValue.processingDateFrom;
    data.processingDateTo = filterValue.processingDateTo;
    data.storageIdList = filterValue?.StorageIdList?.map((item) => item.value);
    delete data.StorageIdList;
    data.date = null;
    data?.storageIdList?.length && (data.date = null);
    data.billingStatusList = Array.isArray(filterValue.billingStatusList) ? _.map(filterValue.billingStatusList, item => item?.value || item) : [];

    if (!data.processingDateFrom && !data.processingDateTo) {
      data.processingDateTo = moment().format("YYYY-MM-DDT00:00:00");
      data.processingDateFrom = moment().subtract(30, 'days').format("YYYY-MM-DDT00:00:00");
    }
    
    dispatch(productBackDetails(filterValue));
    if (filterValue.pageIndex === 1) {
      setFilterValue({ ...filterValue, filterApplied: true, processingDateFrom: data.processingDateFrom, processingDateTo: data.processingDateTo });
      dispatch(getFilterProductsList(data));
    } else {
      setFilterValue({ ...filterValue, searchTxt: "", searchKeywords: "", pageIndex: 1, sortColumn: '', filterApplied: true, processingDateFrom: data.processingDateFrom, processingDateTo: data.processingDateTo });
    }
    setLoader(false);
  };

  const handleDateChange = (date, fieldName) => {
    let dateSelected = date ? moment(date).format("YYYY-MM-DDT00:00:00") : null; 
    setFilterValue({ ...filterValue, [fieldName]: dateSelected });
  };


  const handleMultiSelect = (value, name) => {
    setFilterValue({ ...filterValue, [name]: value });
  };

  return (
    <div className={filterValue.showFilter ? 'fontFix filterContainer show historyFilter zIndex2' : 'fontFix filterContainer historyFilter zIndex2'}>
      <div className='row mb-2'>
        <div className='col-sm-12 col-lg-3 mobMb-10'>
          <div className='row'>
            <div className='col-12'>
              <div className='labelHead'>Warehouse</div>
            </div>
            <div className='col-12'>
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={warehouseTypeList}
                classNamePrefix="list"
                id="warehouseList"
                name="warehouseList"
                value={filterValue?.warehouseList}
                onChange={(value) =>
                  handleChangeFilter(value, "warehouseList")
                }
              />
            </div>
          </div>
        </div>
        <div className='col-sm-12 col-lg-3 mobMb-10'>
          <div className='row carriers'>
            <div className='col-12'>
              <div className='labelHead'>Condition</div>
            </div>
            <div className='col-12'>
              <Select
                isMulti
                options={conditionList}
                classNamePrefix="allCarriers"
                name="conditionList"
                id="conditionList"
                value={filterValue?.conditionList}
                onChange={(value) =>
                  handleChangeFilter(value, "conditionList")
                }
              />
            </div>
          </div>
        </div>

        <div className='col-sm-12 col-lg-3 mobMb-10'>
          <div className='row carriers'>
            <div className='col-12'>
              <div className='labelHead'>Processing Date From</div>
            </div>
            <div className='col-12'>
              <DatePickerComponent
                fieldName={'processingDateFrom'}
                handleDateChange={handleDateChange}
                dateField={filterValue.processingDateFrom}
                isClearable={true}
              />
            </div>
          </div>
        </div>

        <div className='col-sm-12 col-lg-3 mobMb-10'>
          <div className='row'>
            <div className='col-12'>
              <div className='labelHead'>Processing Date To</div>
            </div>
            <div className='col-12'>
              <DatePickerComponent
                fieldName={'processingDateTo'}
                handleDateChange={handleDateChange}
                dateField={filterValue?.processingDateTo}
                isClearable={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='row fontFix'>
        {UserValue?.Value?.roleName !== 'Seller' && (
          <>
            <div className='col-sm-12 col-lg-3 mobMb-10'>
              <div className='row'>
                <div className='col-12'>
                  <div className='labelHead'>Company</div>
                </div>
                <div className='col-12'>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={companyList}
                    classNamePrefix="list"
                    id='companyIdList'
                    name="companyIdList"
                    value={filterValue?.companyIdList}
                    onChange={(value) =>
                      handleChangeFilter(value, "companyIdList")
                    }
                  />
                </div>
              </div>
            </div>
            <div className='col-sm-12 col-lg-3'>
              <div className='row'>
                <div className='col-12'>
                  <div className='labelHead'>Seller</div>
                </div>
                <div className='col-12'>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={sellerList}
                    classNamePrefix="list"
                    id='sellerIdList'
                    name="sellerIdList"
                    value={filterValue?.sellerIdList}
                    onChange={(value) =>
                      handleChangeFilter(value, "sellerIdList")
                    }
                  />
                </div>
              </div>
            </div>
            <div className='col-sm-12 col-lg-3'>
              <div className='row'>
                <div className='col-12'>
                  <div className='labelHead'>Storage ID</div>
                </div>
                <div className='col-12'>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={storageIdListing}
                    classNamePrefix="list"
                    id='StorageIdList'
                    name="StorageIdList"
                    value={filterValue?.StorageIdList}
                    onChange={(value) =>
                      handleChangeFilter(value, "StorageIdList")
                    }
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {filterType !== "allProducts" && (
          <>
            <div className='col-sm-12 col-lg-3 mobMb-10'>
              <div className='row'>
                  <div className='col-12'>
                    <div className='labelHead'>Billing Status</div>
                  </div>
                  <div className='col-12 fontFix'>
                      <Select
                          isMulti
                          closeMenuOnSelect={false}
                          options={BillingStatusList}
                          classNamePrefix="list fontFix"
                          id='billingStatusList'
                          name="billingStatusList"
                          value={filterValue?.billingStatusList || []}
                          onChange={(value) =>
                              handleMultiSelect(value, "billingStatusList")
                          }
                      />
                  </div>
              </div>
            </div>
            <div className='col-sm-12 col-lg-3 mobMb-10'>
              <div className='row mt-2'>
                  <div className='col-12'>
                    <div className='labelHead'>Return Product Type</div>
                  </div>
                  <div className='col-12 fontFix'>
                      <Select
                          isMulti
                          closeMenuOnSelect={false}
                          options={ReturnProductTypeList}
                          classNamePrefix="list fontFix"
                          id='returnProductType'
                          name="returnProductType"
                          value={filterValue?.returnProductType || []}
                          onChange={(value) =>
                              handleMultiSelect(value, "returnProductType")
                          }
                      />
                  </div>
              </div>
            </div>
            <div className='col-sm-12 col-lg-3 mobMb-10'>
              <div className='row mt-2'>
                  <div className='col-12'>
                    <div className='labelHead'>Processing Status</div>
                  </div>
                  <div className='col-12 fontFix'>
                      <Select
                          isMulti
                          closeMenuOnSelect={false}
                          options={statusList}
                          classNamePrefix="list fontFix"
                          id='productStatusId'
                          name="productStatusId"
                          value={filterValue?.productStatusId || []}
                          onChange={(value) =>
                              handleMultiSelect(value, "productStatusId")
                          }
                      />
                  </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="row justify-content-end">
        <div className='col-sm-12 col-lg-3 alignRight'>
          <div className='row'>
            <div className='col-12 justify-content-end pt-4'>
              <button
                className="btn cus-primary-transparent-btn top-btn"
                onClick={handleReset}
              >
                Clear Filter
              </button>
              <button
                className="cus-seconday-bg-btn btn filterBtn"
                onClick={handleApplyFilter}
              >
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

FilterProduct.propTypes = {
  filterValue: PropTypes.object,
  setFilterValue: PropTypes.func,
  handleReset: PropTypes.func,
  setLoader: PropTypes.func,
  sellerList: PropTypes.array,
  setSellerList: PropTypes.func,
  allSellers: PropTypes.array,
  setAllSellers: PropTypes.func,
  filterType: PropTypes.string,
  isSuperAdminUser: PropTypes.bool
}

export default FilterProduct;